import React from 'react';
import { FaTimes } from 'react-icons/fa'; // Import the close icon

const GenerateReportModal = ({ onClose }) => {
    const modalStyle = {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)', // Centering the modal
        zIndex: 1000, // Ensures modal is on top
        backgroundColor: '#fff',
        padding: '30px',
        borderRadius: '8px',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
        width: '400px', // Adjust width as needed
        textAlign: 'center',
    };

    const overlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 999, // Ensure it's behind the modal
    };

    const closeButtonStyle = {
        position: 'absolute',
        top: '-15px',
        right: '-15px',
        backgroundColor: '#dc3545',
        color: 'white',
        fontSize: '14px',
        border: 'none',
        borderRadius: '50px',
        padding: '10px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
    };

    const generateButtonStyle = {
        backgroundColor: '#007bff',
        color: '#fff',
        padding: '10px 15px',
        fontSize: '16px',
        borderRadius: '5px',
        cursor: 'pointer',
        border: 'none',
        position: 'relative',
        marginTop: '20px', // Ensure space between button and content
    };

    const headerStyle = {
        fontSize: '20px',
        fontWeight: 'bold',
        marginBottom: '20px',
    };

    const windowStyle = {
        border: '1px solid #ddd',
        padding: '20px',
        borderRadius: '8px',
        minHeight: '100px', // Ensure there's space for the window content
    };

    return (
        <>
            <div style={overlayStyle} onClick={onClose} />
            <div style={modalStyle}>
                <button style={closeButtonStyle} onClick={onClose}>
                    <FaTimes />
                </button>
                <h2 style={headerStyle}>Generate Report</h2>
                <div style={windowStyle}>
                    {/* This is the centered window in the modal */}
                    Window content goes here...
                </div>
                <button style={generateButtonStyle}>Generate</button>
            </div>
        </>
    );
};

export default GenerateReportModal;
